<script setup lang="ts">
import { useSlider, type SliderProps } from "@formwerk/core";

const props = withDefaults(defineProps<SliderProps & { hideLabel?: boolean }>(), { hideLabel: false });
const { trackProps, groupProps, labelProps, errorMessage, errorMessageProps, useThumbMetadata, isTouched } = useSlider(props);
const thumbData = useThumbMetadata(0);
</script>

<template>
  <div v-bind="groupProps" class="flex w-full flex-col gap-4 pb-2">
    <div v-if="!hideLabel" v-bind="labelProps">
      {{ label }}
    </div>
    <div v-bind="trackProps" class="slider-track">
      <FieldSliderThumb class="-translate-y-2" />
    </div>
    <div v-if="isTouched && errorMessage" v-bind="errorMessageProps" class="text-sm text-danger">
      {{ errorMessage }}
    </div>
  </div>
</template>

<style lang="postcss">
.slider-track {
  @apply relative h-2 w-full rounded-full bg-muted ;
  &::before {
    content: '';
    width: calc(v-bind('thumbData.percent') * 100%);
    @apply absolute inset-0 flex bg-primary h-2 rounded-full;
  }
}
</style>
